export const familyHeavy = "'AvenirLTPro-Heavy', sans-serif";
export const familyMedium = "'AvenirLTPro-Medium', sans-serif";
export const familyBook = "'AvenirLTPro-Book', sans-serif";
export const sizeSm = '0.8rem';
export const sizeLg = '1.8rem';
export const sizeXl = '3.0rem';
export const sizeXxl = '5.0rem';
export const sizeXxxl = '15rem';
